import { render, staticRenderFns } from "./AussieRulesArena.vue?vue&type=template&id=0cf7c779&scoped=true"
import script from "./AussieRulesArena.vue?vue&type=script&lang=js"
export * from "./AussieRulesArena.vue?vue&type=script&lang=js"
import style0 from "./AussieRulesArena.vue?vue&type=style&index=0&id=0cf7c779&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7c779",
  null
  
)

export default component.exports